import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { PromiseType } from 'utility-types';

import { getFormById } from '@app/store/transport-layer/form/forms';

export default function useForm(
  formId: string | null,
  options?: UseQueryOptions<PromiseType<ReturnType<typeof getFormById>>, AxiosError>
) {
  return useQuery<PromiseType<ReturnType<typeof getFormById>>, AxiosError>(
    ['form', formId],
    () => {
      return getFormById(formId ?? '');
    },
    {
      retry: false,
      refetchOnMount: false,
      ...options,
      enabled: !!formId && (options?.enabled === undefined ? true : options.enabled),
    }
  );
}
